
import Utils from "@/assets/js/Utils";
import BoxCom from "@/components/BoxCom.vue";
import DeviceRequestBill from "@/assets/js/Bill/DeviceRequestBill";
import HLSVideo from "@/components/Home/HLSVideo.vue";
import AddrCom from "@/components/AddrCom.vue";
import Vue from "vue";
import HttpUtil from "@/assets/js/HttpUtil";
import Urls from "@/assets/js/Urls";
import { StoreTypes } from "@/assets/js/Types";
import OrderRequestBill from "@/assets/js/Bill/OrderRequestBill";
import rline from "@/components/Charts/RLineChartCom.vue";
import bar from "@/components/Charts/LineChartCom.vue";
import { EchartInitModel } from "@/assets/js/Model/InnerModel";
export default Vue.extend({
  data() {
    return {
      orderMonthChat: [] as any,
      currentSid: "" as string,
      centerTitle: "历史数据",
      deviceLoading: false,
      sid: "" as any,
      deviceDetail: null as any,
      form: {} as any,
      videoDetail: {} as any,
      project: {} as any,
      videoUrl: "",
      alarmList: [] as any,
      videoLoading: false,
      alarmLoading: false,
      orderLoading: false,
      orderLineLoading: false,
      orderList: [] as any,
      tran: Utils.getTran(),
      dataLoading: false,
      urlData: {} as any,
      detail: {} as any,
      dataLogs: [] as any[],
    };
  },
  components: { BoxCom, AddrCom, rline, bar },
  async mounted() {
    this.project = this.$store.state.project[StoreTypes.XC_PROJECT_CURRENT];
    this.sid = this.$route.query.sid;
    await this.getDeviceDetail();
    await this.getALarmList();
    await this.getOrderList();
    await this.getOrderMonthChat();
    await this.getLogs();
  },
  methods: {
    moreAlarm() {
      this.$router.push({ path: `/Home/Camra/Alarm?sid=${this.sid}` });
    },
    async getOrderList() {
      this.orderLoading = true;
      const ret: any = await OrderRequestBill.GetOrders(
        null,
        1,
        1000,
        this.deviceDetail.serial
      );
      this.orderList = ret.data;
      this.orderLoading = false;
    },
    async getOrderMonthChat() {
      this.orderLineLoading = true;
      const req: any = await HttpUtil.XCHttpPost(
        Urls.GetOrderMonthChat,
        this.deviceDetail.sid,
        true,
        true
      );
      this.orderLineLoading = false;
      this.orderMonthChat = req;
      this.initorderMonthChat();
    },

    initdataLineChat() {
      const chart: any = this.$refs.dataLineChart;
      let rdata: any[] = [];
      let rdata2: any[] = [];
      let labels: any[] = [];
      this.dataLogs.forEach((ele: any) => {
        const day = ele.CreateTime;
        rdata.push({ name: day, value: ele.Value1 });
        rdata2.push({ name: day, value: ele.Value2 });
        labels.push(day);
      });
      let opt: EchartInitModel = {
        Data: [
          {
            Name: this.urlData.label1,
            Data: rdata,
          },
        ],
        LegendConfig: {
          top: 10,
          textStyle: {
            color: this.tran ? "#fff" : "#000",
          },
        },
        Labels: labels,
        Colors: ["rgb(243, 141, 10)"],
        Totate: false,
      };
      if (this.urlData.label2) {
        opt.Data.push({
          Name: this.urlData.label2,
          Data: rdata2,
        });
      }
      chart.setOption(opt);
    },
    initorderMonthChat() {
      const chart: any = this.$refs.orderMonthChat;
      let rdata: any[] = [];
      let labels: any[] = [];
      this.orderMonthChat.forEach((ele: any) => {
        const day = ele.day.substr(0, 5);
        rdata.push({ name: day, value: ele.count });
        labels.push(day);
      });
      let opt: EchartInitModel = {
        Data: [
          {
            Name: "工单趋势分析",
            Data: rdata,
          },
        ],
        LegendConfig: {
          top: 10,
          textStyle: {
            color: this.tran ? "#fff" : "#000",
          },
        },
        Labels: labels,
        Colors: ["rgb(243, 141, 10)"],
        Totate: false,
      };
      chart.setOption(opt);
    },
    async getLogs() {
      this.dataLoading = true;
      const ret: any = await HttpUtil.XCHttpPost(
        Urls.GetDeviceHistory,
        { deviceSid: this.sid, count: 60 },
        true,
        true
      );
      this.dataLoading = false;
      this.dataLogs = ret;
      this.initdataLineChat();
    },
    async getALarmList() {
      this.alarmLoading = true;
      const ret: any = await DeviceRequestBill.GetDeviceAlarmBySid(
        null,
        1,
        1000,
        this.sid
      );
      this.alarmList = ret.data;
      this.alarmLoading = false;
    },
    async getNDetail() {
      const ret: any = await HttpUtil.XCHttpPost(
        this.urlData.getUrl,
        this.sid,
        true,
        false
      );
      this.detail = ret;
    },
    async updatePosition() {
      const addr: any = this.$refs.addr;
      const data: any = addr.getData();
      this.form.sid = this.sid;
      this.form.addr = data.addr;
      this.form.lat = data.lat;
      this.form.lng = data.lng;
      await HttpUtil.XCHttpPost(Urls.UpdateDevicePostion, this.form, true, false);
      this.getDeviceDetail();
    },
    async getDeviceDetail() {
      this.deviceLoading = true;
      const ret: any = await DeviceRequestBill.GetDeviceDetail(this.sid, true);
      if (ret && ret.data && ret.data.length == 1) {
        this.deviceDetail = ret.data[0];
        this.currentSid = this.deviceDetail.categorySid;
        this.urlData = Utils.getActionUrl(this.currentSid + "");
        this.getNDetail();
        window.setTimeout(() => {
          const addr: any = this.$refs.addr;
          addr.init({
            addr: this.deviceDetail.addr,
            lat: this.deviceDetail.lat,
            lng: this.deviceDetail.lng,
          });
        }, 2000);
      }
      this.deviceLoading = false;
    },
  },
});
